wbApp.factory('courseSvc', ['$resource', '$q', 'repositorySvc', 'gridSortSvc',
              'accountingBookSvc', 'compensationGroupSvc', 'surveySvc',
    function ($resource, $q, repositorySvc, gridSortSvc, accountingBookSvc, compensationGroupSvc, surveySvc) {

        var Course = $resource('/Api/Courses/Get', {}, {
            'query': { method: 'GET', isArray: true },
            'getByCourseID': { method: 'GET', isArray: false, url: '/Api/Courses/GetByCourseID' },
            'update': { method: 'POST', url: '/Api/Courses/Update' },
            'insert': { method: 'POST', url: '/Api/Courses/Insert' },
            'delete': { method: 'POST', url: '/Api/Courses/Delete' },
            'getFranchiseCourses': { method: 'GET', isArray: true, url: '/Api/Courses/GetFranchiseCourses' },
            'courseCopySave': { method: 'POST', url: '/Api/Courses/CourseCopy' },
        });

        var courses = null;
        var semesterId = null;
        var actions = null;
        var semesterIdActions = null;

        function courseCopySave(model, success, error) {
            return repositorySvc.customPost(
                'courseCopySave',
                Course,
                model,
                success,
                error);
        }

        function getFranchiseCourses() {
            var deferred = $q.defer();

            var courses = [];
            courses.$promise = deferred.promise;

            repositorySvc.customGet('getFranchiseCourses', Course, {}).$promise.then(
                function (data) {
                    courses.push.apply(courses, data);
                    deferred.resolve(courses);
                }, function (reason) {
                    deferred.reject(reason);
                });

            return courses;
        }

        function insert(data, collection, successCallback, errorCallback) {

            function addToCollection(data) {
                return data.subjectCategoryID == 2
                    ? data.semesterID == semesterIdActions
                    : data.semesterID == semesterId;
            }

            repositorySvc.insert(
                Course,               // $resource
                collection,           // collection
                data,                 // entity
                successCallback,
                errorCallback,
                addToCollection);
        }

        function update(data, collection, successCallback, errorCallback) {
            repositorySvc.update(
                Course,            // $resource
                collection,        // collection
                data,              // entity
                successCallback,
                errorCallback,
                'courseID');
        }

        function remove(data, collection, successCallback, errorCallback) {
            repositorySvc.remove(
                Course,               // $resource
                collection,           // collection
                data,                 // entity
                successCallback,      // successCallback
                errorCallback,
                null,
                'courseID');
        }


        function getByCourseID(courseID) {
            return repositorySvc.customGet('getByCourseID', Course, {
                courseID: courseID
            });
        }

        function getAllAsync(sId, reload) {
            if (semesterId !== sId || !courses || reload) {
                courses = repositorySvc.get(Course, { semesterID: sId, isAction: false, openForRegistrationOnly: false });
                semesterId = sId;
            }

            return courses;
        }

        function getAllActionsAsync(sId, reload) {
            if (semesterIdActions !== sId || !actions || reload) {
                actions = repositorySvc.get(Course, { semesterID: sId, isAction: true, openForRegistrationOnly: false });
                semesterIdActions = sId;
            }

            return actions;
        }

        function getActionAsync(sId, courseID, refresh) {
            var deferred = $q.defer();            

            getAllActionsAsync(sId, refresh).$promise.then(function (data) {
                deferred.resolve(_.find(data, { courseID: courseID }));
            }, function (reason) {
                deferred.reject(reason);
            });

            return deferred.promise;
        }

        function getCourseAsync(sId, courseID, refresh) {
            var deferred = $q.defer();

            getAllAsync(sId, refresh).$promise.then(function (data) {
                deferred.resolve(_.find(data, { courseID: courseID }));
            }, function (reason) {
                deferred.reject(reason);
            });

            return deferred.promise;
        }

        function refreshCourseRecord(sId, courseID, collection, success, isAction) {
            var newCourses = repositorySvc.get(Course, { semesterID: sId, isAction: isAction || false, openForRegistrationOnly: false });
            newCourses.$promise.then(function (data) {
                var newRecord = _.find(data, { courseID: courseID });
                var currentRecord = _.find(collection, { courseID: courseID });

                if (newRecord && currentRecord) {
                    angular.extend(currentRecord, newRecord);
                }

                if (success) {
                    success();
                }
            });
        }

        function refreshActionRecord(sId, courseID, collection, success) {
            return refreshCourseRecord(sId, courseID, collection, success, true);
        }

        function getCourseFullName(course) {
            if (!course) {
                return "";
            }

            var ret = course.subjectName;
            if (!!course.abbreviation) {
                ret += " (" + course.abbreviation + ")";
            }

            if (!!course.name) {
                ret += " - " + course.name;
            }

            return ret;
        }

        function get(sId, id) {
            if (courses && semesterId == sId) {
                for (var i = 0; i < courses.length; i++) {
                    var sc = courses[i];
                    if (sc.courseID === id) {
                        return sc;
                    }
                }
            }
            return null;
        }

        function getAction(sId, id) {
            if (actions && semesterIdActions == sId) {
                for (var i = 0; i < actions.length; i++) {
                    var sc = actions[i];
                    if (sc.courseID === id) {
                        return sc;
                    }
                }
            }
            return null;
        }


        function breakFranchiseCoursesByAddress(courses) {
            var addressGroups = _.groupBy(courses, function (course) {
                return '_' + course.classroomLocation.longitude + '_' + course.classroomLocation.latitude;
            });


            var grouping = [];
            for (var property in addressGroups) {
                var locations = addressGroups[property];
                var first = _.head(locations);
                grouping.push({
                    id: first.classroomID,
                    location: {
                        latitude: first.classroomLocation.latitude,
                        longitude: first.classroomLocation.longitude
                    },
                    courses: locations
                });
            }

            return grouping;
        }

        function enhanceFranchiseCoursesAndsort(courses, tenantInfo) {

            courses = _.map(courses, function (course) {
                var tenant = _.find(tenantInfo.franchises, { tenantID: course.tenantID });
                var franchiseLevel = _.find(tenantInfo.franchiseLevels, { franchiseLevelID: tenant.franchiseLevelID });

                if (tenant.name) {
                    course.tenantFriendlyName = tenant.name;
                }

                course.placeName = franchiseLevel.level === 0
                    ? course.tenantFriendlyName
                    : course.address.city;

                course.franchiseLevel = franchiseLevel;

                return course;
            });

            var courses2 = [];

            var groups = _.groupBy(courses, function (course) {
                return course.placeName + '-' + course.franchiseSubjectID;
            });

            for (var key in groups) {
                var group = groups[key];

                if (group.length > 1) {
                    courses2.push({
                        tenantFriendlyName: group[0].tenantFriendlyName,
                        franchiseSubjectID: group[0].franchiseSubjectID,
                        classroomLocation: group[0].classroomLocation,
                        tenantID: group[0].tenantID,
                        address: group[0].address,
                        classroomID: group[0].classroomID,

                        placeName: group[0].placeName,
                        subjectName: group[0].subjectName,
                        courseName: null,//'(' + group.length + ')',
                        teacherSurname: null,
                        firstLessonStartDate: null,
                        courseUrl: null,
                        tenantAlias: group[0].tenantAlias,
                        courseID: group[0].courseID,
                        courses: group,
                        isGroupRow: true,
                        franchiseLevel: group[0].franchiseLevel
                    });
                } else {
                    courses2.push({
                        tenantFriendlyName: group[0].tenantFriendlyName,
                        franchiseSubjectID: group[0].franchiseSubjectID,
                        classroomLocation: group[0].classroomLocation,
                        tenantID: group[0].tenantID,
                        address: group[0].address,
                        classroomID: group[0].classroomID,

                        placeName: group[0].placeName,
                        subjectName: group[0].subjectName,
                        courseName: group[0].courseName,
                        teacherSurname: group[0].teacherSurname,
                        firstLessonStartDate: group[0].firstLessonStartDate,
                        courseUrl: group[0].courseUrl,
                        tenantAlias: group[0].tenantAlias,
                        courseID: group[0].courseID,
                        courses: group,
                        isGroupRow: false,
                        franchiseLevel: group[0].franchiseLevel
                    });
                }
            }

            courses = _.map(courses2, function (course) {
                if (course.courses.length > 1) {
                    course.courseUrl = '==group==';
                } else {
                    course.courseUrl = "https://" + course.tenantAlias + tenantInfo.domain + "/Courses/Register/" + course.courseID;
                }
                angular.forEach(course.courses, function (c) {
                    c.courseUrl = "https://" + c.tenantAlias + tenantInfo.domain + "/Courses/Register/" + c.courseID;
                    c.placeName = c.franchiseLevel.level === 0
                        ? c.tenantFriendlyName
                        : c.address.city;
                });
                return course;
            });

            var ret = _.sortBy(courses,[
                function (n) {
                    return n.franchiseLevel.level;
                },
                function (n) {
                    if (n.franchiseLevel.level === 0) {
                        return gridSortSvc.locale(n.tenantFriendlyName);
                    } else {
                        return gridSortSvc.locale(n.address.city);
                    }
                }, function (n) {
                    var startDate = moment(n.firstLessonStartDate);
                    return moment('2000-1-1')
                            .add(startDate.day(), 'day')
                            .add(startDate.hour(), 'hour')
                            .add(startDate.minute(), 'minute');
                }]);

            return ret;
        }

        function createNew(semesterID, isAction) {

            var dfAccountingBookPromise = accountingBookSvc.getDefaultAsync();
            var dfCompensationGroupPromise = compensationGroupSvc.getDefaultAsync();
            var dfSurveyPromise = surveySvc.getDefaultAsync();

            var deferred = $q.defer();

            var model = {
                semesterID: semesterID,
                showInSchedule: true,
                allowRegistration: true,
                showInEmployeeTimeSheet: true,
                emailCategory: 1,
                lessonLengthInMinutes: 45,
                courseCategoryID: 1,
                courseAgeRangeID: 1,
                subjectCategoryID: isAction ? 2 : 1,
                amortizationSchedules: []
            };

            if (!!isAction) {
                model.picture = "Generic/0/children01.png";
            }

            $q.all([dfAccountingBookPromise, dfCompensationGroupPromise, dfSurveyPromise]).then(function (data) {
                if (!!data[0]) {
                    model.accountingBookID = data[0].id;
                }
                if (!!data[1]) {
                    model.compensationGroupID = data[1].id;
                }
                if (!!data[2]) {
                    model.surveyID = data[2].surveyID;
                }
            });

            model.$promise = deferred.promise;

            return model;
        }

        return {
            getAllAsync: getAllAsync,
            getAllActionsAsync: getAllActionsAsync,
            getCourseFullName: getCourseFullName,
            get: get,
            getByCourseID: getByCourseID,
            getAction: getAction,
            getFranchiseCourses: getFranchiseCourses,
            breakFranchiseCoursesByAddress: breakFranchiseCoursesByAddress,
            enhanceFranchiseCoursesAndsort: enhanceFranchiseCoursesAndsort,
            insert: insert,
            update: update,
            remove: remove,
            createNew: createNew,
            refreshActionRecord: refreshActionRecord,
            refreshCourseRecord: refreshCourseRecord,
            getActionAsync: getActionAsync,
            getCourseAsync: getCourseAsync,
            courseCopySave: courseCopySave
        }
    }
]);